import Text, { Inline } from 'components/base/Text';
import { startCase } from 'lodash';
import { providerLogos } from 'common/services/sensors.service';
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import { SENSOR_TYPES } from 'common/constants/constants';

const formatSensorNameText = sensorName => {
  const splitText = sensorName.split('_').join(' ');
  return startCase(splitText);
};

const SensorDescription = ({ sensorAuthorization, color, prefix = '' }) => {
  const sensorName = sensorAuthorization?.sensor_name;
  const isPm = sensorAuthorization?.sensor_type_id === SENSOR_TYPES.PM;
  const name = isPm
    ? formatSensorNameText(sensorName)
    : sensorAuthorization?.name;

  return (
    <Flex items='center'>
      <img
        alt={`${sensorName} logo`}
        src={providerLogos[sensorName]}
        style={{ width: '1.7rem', fill: color, stroke: color }}
      />
      <Inline pl={SPACES['x-small']}>
        <Text size='large' weight='400' color={color}>
          {`${prefix}${name}`}
        </Text>
      </Inline>
    </Flex>
  );
};

export default SensorDescription;
